import React from 'react';
import { Row, Col, Button } from 'antd';
import useScrollReveal from './useScrollReveal';

const FlexText = ({ titleEn, titleCh, contentCh, contentEn, onMoreClick }) => {
  useScrollReveal();
  return (
    <section>
      <div className="container-narrow">
        <Row gutter={[48, 24]} align="top">
          {/* 左側標題區 */}
          <Col xs={24} md={8}>
            <div className="narrow-title-box reveal reveal-right">
              <div className="title-en">{titleEn}</div>
              <h2 className="title-ch">{titleCh}</h2>
            </div>
          </Col>

          {/* 右側文字與按鈕區 */}
          <Col xs={24} md={16}>
            <div className="narrow-content-box reveal reveal-right">
              <div className="content-ch">
                {contentCh}
              </div>
              <div className="content-en mb-30">
                {contentEn}
              </div>
              {/* 只有在傳入 onMoreClick 時才渲染按鈕 */}
              {onMoreClick && (
                <Button className="find-more-btn" onClick={onMoreClick}>
                  Find Out More
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default FlexText;